import { render, staticRenderFns } from "./formYoutube.vue?vue&type=template&id=b126926c"
import script from "./formYoutube.vue?vue&type=script&lang=js"
export * from "./formYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b126926c')) {
      api.createRecord('b126926c', component.options)
    } else {
      api.reload('b126926c', component.options)
    }
    module.hot.accept("./formYoutube.vue?vue&type=template&id=b126926c", function () {
      api.rerender('b126926c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/formNetwork/formYoutube.vue"
export default component.exports